<br>
<app-projectlist></app-projectlist>


<!-- <mat-card style="padding-left: 0px;padding-right: 0px;padding-top:0px;">
  <mat-card-content>
    <mat-tab-group class="demo-tab-group" #tabgroup (selectedTabChange)="checkChange($event)">
      <mat-tab label="INFRASTRUCTURE PROJECTS" tabindex="0">
        <br>
        <app-projectlist></app-projectlist>

      </mat-tab>


      <mat-tab label="PUBLIC SAFETY PROJECTS" tabindex="0">
        <br>
        <app-projectlist></app-projectlist>
      </mat-tab>


    </mat-tab-group>
  </mat-card-content>
</mat-card> -->
